import type { ComponentMap } from '@atlassian/forge-ui/dist/types/renderer/util';
import { PortalTextArea } from './portalTextarea';

export const requestCreatePropertyPanelUIKitComponents: ComponentMap = {
    PortalTextArea,
};
